module.exports = __webpack_public_path__ + "img/logo.ac3beb53.png";